import { css } from '@emotion/react/macro'

export const oneDpShadowCss = css`
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.12),
    0px 0px 2px rgba(0, 0, 0, 0.14);
`

export const twoDpShadowCss = css`
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.14);
`

export const threeDpShadowCss = css`
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12),
    0px 3px 3px rgba(0, 0, 0, 0.14);
`

export const fourDpShadowCss = css`
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.14);
`

export const sixDpShadowCss = css`
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 6px 10px rgba(0, 0, 0, 0.14);
`

export const eightDpShadowCss = css`
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2), 0px 3px 14px rgba(0, 0, 0, 0.12),
    0px 8px 10px rgba(0, 0, 0, 0.14);
`

export const tenDpShadowCss = css`
  box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12),
    0px 9px 12px rgba(0, 0, 0, 0.14);
`

export const twelveDpShadowCss = css`
  box-shadow: 0px 7px 8px rgba(0, 0, 0, 0.2), 0px 5px 22px rgba(0, 0, 0, 0.12),
    0px 12px 17px rgba(0, 0, 0, 0.14);
`

export const twentyFourDpShadowCss = css`
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12),
    0px 11px 15px rgba(0, 0, 0, 0.2);
`

export const paperShadowCss = css`
  box-shadow: 0px 2px 4px rgba(52, 67, 94, 0.235686);
`

export const containerShadowCss = css`
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14);
`
